import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import LazyLoad, { forceCheck } from 'react-lazyload';
import st from './styles.module.scss';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import GetProposal from '../../components/proposal/ppc/GetProposal';
import Pricing from '../../components/video-production/Pricing';
import ViewMore from '../../components/ViewMore';

const HealthcareProblems = dynamic(() => import('../../components/healthcare/HealthcareProblems'), {
  suspense: true,
});
const SolveProblems = dynamic(() => import('../../components/healthcare/SolveProblems'), {
  suspense: true,
});

const HealthCare = props => {
  useEffect(() => {
    forceCheck();
  }, []);
  const [showModalPPC, setShowModalPPC] = useState(false);
  const [showPricingModalState, setShowPricingModalState] = useState(false);

  const setHidden = () => {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  };
  const hideOfferModalPPC = () => {
    setShowModalPPC(false);
    if (document.getElementById('form-ppc')) document.getElementById('form-ppc').reset();
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
  };
  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing?type=healthcare';
    } else {
      // document.getElementById('pricing-form').reset();
      setShowPricingModalState(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalState(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
  };
  return (
    <>
      <Head>
        <title>Video Production - Healthcare & Pharmaceutical Videos | Prodigi</title>
        <meta httpEquiv="ScreenOrientation" content="autoRotate:disabled" />
        <meta
          name="description"
          content="Explore Prodigi video production services for the healthcare and pharmaceutical industries. Enhance visibility, engage patients, and expand your practice."
        />
        <meta property="og:url" content="https://weprodigi.com/healthcare" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - Healthcare & Pharmaceutical Videos | Prodigi" />
        <meta
          property="og:description"
          content="Explore Prodigi video production services for the healthcare and pharmaceutical industries. Enhance visibility, engage patients, and expand your practice."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/healthcare/healthcare.jpg" />
      </Head>
      <div className="main">
        <div className={`relative w-full  h-intro  overflow-hidden   `}>
          <video
            width="100%"
            height="100%"
            autoPlay
            loop
            muted
            playsInline
            preload="none"
            id="header-11"
            className={'absolute h-intro md:h-full ' + st['header-mp4']}
          >
            <source src="https://weprodigi.com/uploads/images/healthcare/healthcare_header_compressed.mp4" type="video/mp4" />
          </video>
          <div className="container h-full">
            <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
              <h1 className="capitalize text-white text-30 md:text-60 font-bolder leading-none">
                Healthcare & <span className="block leading-[45px] md:leading-none mt-10 md:mt-20">Pharmaceutical Videos</span>
              </h1>

              <div onClick={showPricingModal} className={'cursor-pointer icon-green mt-23 md:mt-0'}>
                <style>{`
                                    .icon-green .icon-calculator-container .icon-calculator {
                                        filter: brightness(0) invert(1) !important;
                                    }
                                     .card-rounded{
                                          border-radius: 20px 20px 20px 20px;
                                        }
                                        .bg-review{
                                          background-size:cover!important;
                                         background-position: bottom!important;
                                         height:320px;
                                       }
                                          @media screen and (max-width:768px){
                                             .bg-review{
                                               /*// background:unset;*/
                                               height:unset;
                                             }
                                         }
                                `}</style>
                <a className="calculate-price-header relative z-10  md:inline-block border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-5 bg-green-badge hover:bg-green-hover hover:text-white transition-all icon-calculator-container transition-400">
                  <span className="icon icon-calculator" />
                  Get Pricing
                </a>
              </div>
            </div>
          </div>
        </div>
        <LazyLoad height={200} once>
          <div className={'bg-white py-24'}>
            <div className="container flex flex-wrap md:flex-nowrap justify-between">
              <div className="w-full md:w-half-auto hidden md:block">
                <img src="https://weprodigi.com/uploads/images/healthcare/healthcare2_21.jpg" width={'100%'} height={100} alt="we rock digital" />
              </div>
              <div className="w-full md:w-half-auto mt-18 md:mt-0  hidden md:block">
                Healthcare and pharmaceutical industries, as the most critical and, at the same time, most vulnerable ones, require all the power of
                digital and smart technologies. The segment that badly needs automation also feels the communication gap with patients. While smart
                technologies managed to transform the healthcare system and compress it into patients’ smartphones or computers, communication and
                interaction still remained a bottleneck in the industry. Due to the industry's historically secretive and complex pursuits, the public
                has traditionally felt suspicious and skeptical of the industry. To dispel the fear around healthcare and improve patient-doctor
                communication, the industry found quite an effective strategy through video content that explains complicated processes in interactive
                and simple ways so that everyone can understand.
              </div>
              <div className="w-full md:w-half-auto mt-18 md:mt-0  block md:hidden">
                <ViewMore ln={40}>
                  Healthcare and pharmaceutical industries, as the most critical and, at the same time, most vulnerable ones, require all the power of
                  digital and smart technologies. The segment that badly needs automation also feels the communication gap with patients. While smart
                  technologies managed to transform the healthcare system and compress it into patients’ smartphones or computers, communication and
                  interaction still remained a bottleneck in the industry. Due to the industry's historically secretive and complex pursuits, the
                  public has traditionally felt suspicious and skeptical of the industry. To dispel the fear around healthcare and improve
                  patient-doctor communication, the industry found quite an effective strategy through video content that explains complicated
                  processes in interactive and simple ways so that everyone can understand.
                </ViewMore>
              </div>
            </div>
          </div>
        </LazyLoad>
        <LazyLoad height={200} once>
          <div className={'bg-gray-white py-24'}>
            <div className="container">
              <video
                controls
                className="float-right pl-0 md:pl-20 pb-10 w-full md:w-half-auto hidden md:block"
                poster={'https://weprodigi.com/uploads/images/healthcare/poster_4.jpg'}
              >
                <source src="https://weprodigi.com/uploads/images/healthcare/videoplayback4.mp4" type="video/mp4" />
              </video>
              <div>
                <h2 className={'w-full md:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
                  What is medical video animation?
                </h2>
                <video
                  controls
                  className="float-right pl-0 md:pl-20 pb-10 w-full md:w-half-auto block md:hidden mt-23 mb-10"
                  poster={'https://weprodigi.com/uploads/images/healthcare/poster_4.jpg'}
                >
                  <source src="https://weprodigi.com/uploads/images/healthcare/videoplayback4.mp4" type="video/mp4" />
                </video>
                <p className={'mt-20 hidden md:block'}>
                  Medical video animation is a blend of science and creativity, much like the medical profession. Being extremely important, videos
                  are created with the greatest precision while not losing their innovative and visionary impression. Only a professional video
                  production team with relevant expertise can and should take responsibility for creating medical animations. In general, the audience
                  of medical videos is medical staff and patients. The medical staff needs short and to-the-point videos, while patients require
                  simple explanations of complicated things. The golden middle can be reached with professional video targeting both groups. With the
                  rapidly growing popularity of social media platforms and video content as a highly effective form of gaining engagement, medical
                  video animation tailored to specific requirements may be even more effective than long-form written content or any other type of
                  guide.
                </p>
                <div className={'mt-20 block md:hidden'}>
                  <ViewMore ln={40}>
                    Medical video animation is a blend of science and creativity, much like the medical profession. Being extremely important, videos
                    are created with the greatest precision while not losing their innovative and visionary impression. Only a professional video
                    production team with relevant expertise can and should take responsibility for creating medical animations. In general, the
                    audience of medical videos is medical staff and patients. The medical staff needs short and to-the-point videos, while patients
                    require simple explanations of complicated things. The golden middle can be reached with professional video targeting both groups.
                    With the rapidly growing popularity of social media platforms and video content as a highly effective form of gaining engagement,
                    medical video animation tailored to specific requirements may be even more effective than long-form written content or any other
                    type of guide.
                  </ViewMore>
                </div>
              </div>
              <br className={'clear-both hidden'} />
            </div>
          </div>
        </LazyLoad>
        <LazyLoad height={200} once>
          <div className={'bg-white py-24'}>
            <div className="container">
              <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
                What video types are used for healthcare companies?
              </h2>
              <p className={'mt-20'}>
                Whether you are introducing a new product or want to launch a digital marketing campaign with video content, the animated medical
                video will give the anticipated user engagement. Three types of videos drive targeted traffic depending on the campaign, product, or
                service specifics.
              </p>

              <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
                <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                  <video width="540" controls className="w-full" poster={'https://weprodigi.com/uploads/images/healthcare/poster_2.jpg'}>
                    <source src="https://weprodigi.com/uploads/images/healthcare/videoplayback2.mp4" type="video/mp4" />
                  </video>
                  <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Tap'N'Care | 2D Explainer Animation</p>
                </div>

                <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                  <h3 className="text-purple font-bold text-24   leading-none">Explainer Videos</h3>
                  <div className={'mt-16 hidden md:block'}>
                    <ViewMore ln={80}>
                      While your healthcare technology or product may be life-changing, and the services you provide as a qualified physician may be
                      exceptional, it is more important to help your consumers understand and trust what you provide. More than that, they need to
                      feel secure. Today, patients carry out research before turning to a doctor making sure the medical practitioner and medical
                      institution before visiting. This is where healthcare explainer videos may assist educate empowering your audience to make
                      decisions. Carefully crafted and visually engaging videos convey a clear, compelling, and concise message. An experienced video
                      production agency with relevant expertise can create impactful healthcare explainer videos explaining complicated processes and
                      medical terminology in simple animations, educating and helping patients understand the treatment.
                    </ViewMore>
                  </div>
                  <div className={'mt-16 block md:hidden'}>
                    <ViewMore ln={40}>
                      While your healthcare technology or product may be life-changing, and the services you provide as a qualified physician may be
                      exceptional, it is more important to help your consumers understand and trust what you provide. More than that, they need to
                      feel secure. Today, patients carry out research before turning to a doctor making sure the medical practitioner and medical
                      institution before visiting. This is where healthcare explainer videos may assist educate empowering your audience to make
                      decisions. Carefully crafted and visually engaging videos convey a clear, compelling, and concise message. An experienced video
                      production agency with relevant expertise can create impactful healthcare explainer videos explaining complicated processes and
                      medical terminology in simple animations, educating and helping patients understand the treatment.
                    </ViewMore>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
                <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                  <h3 className="text-purple font-bold text-24 leading-none">Product Videos</h3>
                  <p className={'mt-16'}></p>

                  <p className={'mt-16 hidden md:block'}>
                    Carefully crafted and visually engaging videos convey a clear, compelling, and concise message. An experienced video production
                    agency with relevant expertise can create impactful healthcare explainer videos explaining complicated processes and medical
                    terminology in simple animations, educating and helping patients understand the treatment.
                  </p>
                  <div className={'mt-16 block md:hidden'}>
                    <ViewMore ln={40}>
                      While your healthcare technology or product may be life-changing, and the services you provide as a qualified physician may be
                      exceptional, it is more important to help your consumers understand and trust what you provide. More than that, they need to
                      feel secure. Today, patients carry out research before turning to a doctor making sure the medical practitioner and medical
                      institution before visiting. This is where healthcare explainer videos may assist educate empowering your audience to make
                      decisions. Carefully crafted and visually engaging videos convey a clear, compelling, and concise message. An experienced video
                      production agency with relevant expertise can create impactful healthcare explainer videos explaining complicated processes and
                      medical terminology in simple animations, educating and helping patients understand the treatment.
                    </ViewMore>
                  </div>
                </div>
                <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                  <video width="540" controls className="w-full  " poster={'https://weprodigi.com/uploads/images/healthcare/poster_5.jpg'}>
                    <source src="https://weprodigi.com/uploads/images/healthcare/videoplayback5.mp4" type="video/mp4" />
                  </video>
                  <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>C-Pro | Healthcare Product Video</p>
                </div>
              </div>
              <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
                <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                  <video width="540" controls className="w-full" poster={'https://weprodigi.com/uploads/images/healthcare/poster_3.jpg'}>
                    <source src="https://weprodigi.com/uploads/images/healthcare/videoplayback3.mp4" type="video/mp4" />
                  </video>
                  <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Desert Teleheart | Mixed Media Animation</p>
                </div>

                <div className={'w-full md:w-half-auto '}>
                  <h3 className="text-purple font-bold text-24 leading-none">Mixed Media</h3>
                  <p className={'mt-16 hidden md:block'}>
                    Advanced technologies, enabling the mixing of 2D/3D animation with videos and images, are an efficient way to present medical
                    topics in a more interactive way. Being the most popular healthcare video type, mixed media videos present compelling information
                    without spending resources on video production technologies. Simply put, mixed media video is an affordable solution for
                    healthcare marketing. Whether it is a product video, explainer video, patient testimonial, or educational content, animated
                    elements make it catchy, more engaging, and attractive to users. This format has proven efficient for talking about “serious
                    things” in a more “entertaining” way.
                  </p>
                  <div className={'mt-16 block md:hidden'}>
                    <ViewMore ln={'40'}>
                      Advanced technologies, enabling the mixing of 2D/3D animation with videos and images, are an efficient way to present medical
                      topics in a more interactive way. Being the most popular healthcare video type, mixed media videos present compelling
                      information without spending resources on video production technologies. Simply put, mixed media video is an affordable solution
                      for healthcare marketing. Whether it is a product video, explainer video, patient testimonial, or educational content, animated
                      elements make it catchy, more engaging, and attractive to users. This format has proven efficient for talking about “serious
                      things” in a more “entertaining” way.
                    </ViewMore>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LazyLoad>
        <LazyLoad height={200} once>
          <div className={'bg-gray-light py-24'}>
            <div className="container">
              <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
                What are the problems of the healthcare and pharmaceutical industries?
              </h2>
              <p className={'mt-20'}>
                The healthcare and pharmaceutical industries deal with complexity on many levels - from processes and procedures to innovations and
                breakthroughs that could save lives. Being clear and sensitive is more crucial than ever. Three significant problems acted as
                pressures for integrating innovations into healthcare.
              </p>
              <Suspense fallback={`Loading...`}>
                <HealthcareProblems />
              </Suspense>
            </div>
          </div>
        </LazyLoad>
        <LazyLoad height={200} once>
          <div className={'bg-white py-24'}>
            <div className="container">
              <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
                How can medical video production solve these problems?
              </h2>
              <p className={'mt-20'}>
                With proven efficiency, pharmaceutical and healthcare videos may help those industries improve audience engagement.
              </p>
              <Suspense fallback={`Loading...`}>
                <SolveProblems />
              </Suspense>
            </div>
          </div>
        </LazyLoad>

        <LazyLoad height={0} once>
          <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
            <div id="stars" />
            <div id="stars2" />
            <div id="stars3" />
            <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
              <div className={'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-36'}>
                CALCULATE YOUR HEALTHCARE VIDEO COST <br />
                <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                  Answer five questions and get to know the price!
                </span>
                <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                  <button
                    className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                    onClick={showPricingModal}
                  >
                    Start Now
                  </button>
                </div>
              </div>
              <img src="https://weprodigi.com/uploads/images/healthcare/Eva1.webp" alt="eva" />
            </div>
          </div>
        </LazyLoad>
        <LazyLoad height={200} once>
          <div className={'bg-gray-white py-24'}>
            <div className="container">
              <h2 className={'w-full md:w-70p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
                More benefits of using medical animated videos
              </h2>
              <p className="mt-24">
                As part of the pharmaceutical and healthcare marketing, medical videos hit big to market the products and services. There are multiple
                advantages to using video for marketing and patient education. So, how important is video creation in healthcare practice?
              </p>
              <div className="mt-24 flex flex-wrap   justify-between items-start ">
                <div className={'w-full md:w-half-auto flex items-start'}>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="mt-2 w-20" viewBox="0 0 20 20" fill="#8DC63F">
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <p className="pl-10">
                    Presenting a new concept or discovery, new drug, or innovative medical device empowered by other marketing campaigns to increase
                    brand awareness.
                  </p>
                </div>
                <div className={'w-full md:w-half-auto flex  items-start'}>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="mt-2 w-20" viewBox="0 0 20 20" fill="#8DC63F">
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <p className="pl-10">Enhancing the education of healthcare professionals through short, interactive videos.</p>
                </div>
                <div className={'w-full md:w-half-auto flex  items-start mt-16'}>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="mt-2 w-20" viewBox="0 0 20 20" fill="#8DC63F">
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <p className="pl-10"> Creating a positive brand image by simplifying complex medical terms and building trust.</p>
                </div>

                <div className={'w-full md:w-half-auto flex justify-start items-start mt-16'}>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="mt-2 w-20" viewBox="0 0 20 20" fill="#8DC63F">
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <p className="pl-10">Accessible video content from any device and viewed anywhere.</p>
                </div>

                <div className={'w-full md:w-half-auto flex justify-start items-start mt-16'}>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="mt-2 w-20" viewBox="0 0 20 20" fill="#8DC63F">
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <p className="pl-10">Improved telehealth services by providing before and after explanatory videos for patients.</p>
                </div>
              </div>
            </div>
          </div>
        </LazyLoad>
        <LazyLoad height={200} once>
          <div className={'bg-white py-24'}>
            <div className="container">
              <div className="flex flex-wrap md:flex-nowrap justify-between">
                <div className="w-full md:w-half-auto">
                  <h2 className={'font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
                    How to Choose the Right Video Production Agency for your Healthcare video?
                  </h2>
                  <p className="mt-16">
                    Short, engaging videos with creative animation will be more effective than hours of presentation filled with hard-to-understand
                    terminology. The biggest challenge of creating a captivating professional video is the expertise of the video production agency
                    you have turned to. There are, if not thousands, then hundreds of video production agencies in your country or abroad offering
                    services. But how to find the one that will meet your objectives and be experienced enough to deliver quality? Here are some tips
                    to consider:
                  </p>
                </div>
                <div className="w-full md:w-half-auto mt-10 md:mt-0">
                  <div className="rounded-5 bg-red-headerInner py-10 px-17">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={15}
                      className="pt-5 float-left"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#670F7A"
                      strokeWidth={3}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                    When researching video production agencies, ensure the shortlisted ones have relevant background and experience in the industry,
                    understand the healthcare needs to the core, and possess up-to-date tools to create a professional video
                  </div>
                  <div className="rounded-5 bg-red-headerInner py-10 px-17 mt-16 ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={15}
                      className="pt-5 float-left"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#670F7A"
                      strokeWidth={3}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                    Find out whether the agency has a professional script writer or not. The video script is one of the most significant details to
                    take care of. The final video will be obscure and unappealing if the scriptwriter is not professional enough.
                  </div>
                  <div className="rounded-5 bg-red-headerInner py-10 px-17 mt-16  ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={15}
                      className="pt-5 float-left"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#670F7A"
                      strokeWidth={3}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                    Make sure the agency you have chosen doesn’t use templates for videos. The modern market is flooded with videos built on
                    templates; they look similar and generate absolutely no impression. To make your video unique, it should have custom details
                    visualizing your brand identity, so your target audience remembers you.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LazyLoad>
        <LazyLoad once height={300}>
          <div className={` scale-y-1  height-transition `}>
            <div className={'bg-review  mt-20 md:mt-0 ' + st['review-3']}>
              <div className={'container mt-0 md:mt-0 h-full flex flex-wrap md:flex-nowrap justify-between items-center pb-30 md:pb-0'}>
                <div className={'w-full md:w-auto mt-0 md:mt-0  py-24'}>
                  <p className={'text-white md:text-white text-20 md:text-32 leading-24 md:leading-39 font-400 max-w-650'}>
                    We've driven <span className={'text-green font-bolder'}>86,300,000 video views</span> for our clients through video production
                    services.
                  </p>
                  <p className="text-white md:text-white font-normal-700 text-20 md:text-32 leading-24 md:leading-39">
                    Discover how we can help your business
                  </p>
                  {/*<button className={'w-full md:w-auto mt-24 text-white bg-green rounded-5 px-23 py-5'}>Send me a proposal</button>*/}
                  <div className={'w-full hidden md:flex'}>
                    <a
                      href={'https://weprodigi.com/video-production'}
                      className="text-center capitalize hover:bg-purple-overlay  block w-full md:w-auto mt-24 text-white bg-purple rounded-5 px-23 py-5"
                    >
                      see full service
                    </a>
                    <a
                      className="hidden ml-20  hover:bg-green-hover md:block w-full md:w-auto mt-24 text-white bg-green rounded-5 px-23 py-5"
                      href={'https://calendar.app.google/uJZkJfztLwHZcfkC7'}
                      target={'_blank'}
                    >
                      {' '}
                      Schedule a Call
                    </a>
                    <a
                      className="block  hover:bg-green-hover md:hidden text-center w-full md:w-auto mt-24 text-white bg-green rounded-5 px-23 py-5"
                      href={'https://calendar.app.google/uJZkJfztLwHZcfkC7'}
                      target={'_blank'}
                    >
                      {' '}
                      Schedule a Call
                    </a>
                  </div>
                </div>
                <div className={'w-full md:w-auto  md:block pl-0 md:pl-40'}>
                  <p className="text-white font-normal-700 text-18 md:text-18 leading-28 mb-10 md:mb-0 md:leading-39">
                    What our video production clients say
                  </p>
                  <div className="bg-white shadow-lg min-h-280 md:min-h-250   card-rounded py-25 px-14 flex justify-start items-start relative">
                    <img
                      src="https://weprodigi.com/uploads/images/home-page/Formatquote.svg"
                      className={'-mt-12'}
                      width={55}
                      height={55}
                      alt="format quote"
                    />
                    <div className={'relative max-w-320'}>
                      <p className={'text-16 text-black leading-20 font-400'}>
                        Their creativity and passion for the project is impressive. Their ability to work to tight schedules and meet deadlines. Their
                        ability to think outside the box especially during the COVID-19 restrictions .
                      </p>
                      <p className={'text-purple text-16 leading-20 font-bolder mt-16'}>Johnson Samuyiwa, Director </p>
                      <p className="text-black text-16 leading-20  mt-8">SelectTVFormats LTD</p>
                    </div>
                    <a
                      aria-label={'view more'}
                      href="https://clutch.co/profile/weprodigi-agency?page=3&project_cost=&review_type=&service_provided=&sort_by=date_DESC#review-1651937"
                      target={'_blank'}
                      className={'text-purple text16 font-bolder flex items-center absolute bottom-15 hover-arrow right-30'}
                    >
                      More
                      <svg xmlns="http://www.w3.org/2000/svg" width={18} viewBox="0 0 20 20" fill="currentColor">
                        <path
                          fillRule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </a>
                  </div>
                  <div className={'w-full flex md:hidden'}>
                    <a
                      href={'https://weprodigi.com/video-production'}
                      className="text-center text-16 capitalize hover:bg-purple-overlay  block w-full md:w-auto mt-24 text-white bg-purple rounded-5  px-0 md:px-23 py-5"
                    >
                      see full service
                    </a>
                    <a
                      className="block  md:hidden text-center text-16 w-full md:w-auto mt-24 ml-20 text-white bg-green hover:bg-green-hover rounded-5 px-none md:px-23 py-5"
                      href={'https://calendar.app.google/uJZkJfztLwHZcfkC7'}
                      target={'_blank'}
                    >
                      Get Pricing
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LazyLoad>
      </div>
      <GetProposal
        from={'contact'}
        country={props.country}
        show={showModalPPC}
        id={'form-ppc'}
        hide={hideOfferModalPPC}
        website={''}
        currency={props.currency}
      />
      <Pricing from="healthcare" videoLength={[]} script={''} country={props.country} show={showPricingModalState} hide={hidePricingModal} step={1} />
    </>
  );
};

export default HealthCare;
